var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Form } from 'react-bootstrap';
export const TextareaInput = forwardRef((_a, ref) => {
    var _b;
    var { type, isInvalid, label, value } = _a, rest = __rest(_a, ["type", "isInvalid", "label", "value"]);
    const parsedValue = (_b = value === null || value === void 0 ? void 0 : value.replaceAll('#', '\n')) === null || _b === void 0 ? void 0 : _b.replaceAll(';', '\n\n');
    return (_jsxs(_Fragment, { children: [_jsx(Form.Label, Object.assign({ htmlFor: rest.name }, { children: label })), _jsx(Form.Control, Object.assign({}, rest, { id: rest.name, name: rest.name, ref: ref, value: parsedValue, as: 'textarea', rows: 4, isInvalid: isInvalid }))] }));
});
TextareaInput.displayName = 'TextareaInput';
